/** @jsx jsx */
import React from 'react'
import {jsx, useColorMode} from 'theme-ui'
// import BGPattern from "../assets/bg-pattern"

const HeaderBackground = () => {
  // const [colorMode] = useColorMode()
  // const isDark = colorMode === `dark`

  return (
    <div
      sx={{
        position: `absolute`,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'white',
        background: `linear-gradient(to top, #fad0c4 0%, #ffd1ff 100%)`,
      }}
    />
  )
}

export default HeaderBackground
